/**
 * Footer Accordion Component
 * Handles mobile accordion functionality for footer menus
 */

const MOBILE_BREAKPOINT = 768;
let accordions = [];

class FooterAccordion {
  constructor(button) {
    this.button = button;
    this.blockId = button.getAttribute('data-accordion-trigger');
    this.content = document.getElementById(`footer-content-${this.blockId}`);
    
    if (!this.content) return;

    this.isOpen = false;
    this.init();
  }

  init() {
    this.handleClick = this.toggle.bind(this);
    this.button.addEventListener('click', this.handleClick);
    this.handleResize();
  }

  toggle() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;

    this.isOpen = !this.isOpen;
    this.content.classList.toggle('is-open', this.isOpen);
    this.button.setAttribute('aria-expanded', this.isOpen);
  }

  handleResize() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      this.isOpen = false;
      this.content.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
    }
  }

  destroy() {
    if (this.handleClick) {
      this.button.removeEventListener('click', this.handleClick);
    }
  }
}

/**
 * Initialize footer accordions
 */
function initFooterAccordions() {
  const buttons = document.querySelectorAll('[data-accordion-trigger]');
  accordions = Array.from(buttons).map(button => new FooterAccordion(button));

  // Handle resize with debounce
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      accordions.forEach(accordion => accordion.handleResize());
    }, 150);
  };

  window.addEventListener('resize', handleResize);

  // Store cleanup function
  window.footerCleanup = () => {
    accordions.forEach(accordion => accordion.destroy());
    window.removeEventListener('resize', handleResize);
    accordions = [];
  };
}

/**
 * Cleanup function
 */
function cleanupFooterAccordions() {
  if (window.footerCleanup) {
    window.footerCleanup();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterAccordions);
} else {
  initFooterAccordions();
}

// Cleanup on theme editor reload
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:unload', cleanupFooterAccordions);
  document.addEventListener('shopify:section:load', initFooterAccordions);
}

// Cleanup on page unload
window.addEventListener('beforeunload', cleanupFooterAccordions);